import { useCallback, useMemo, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/typedReduxHooks'
import { setWorkLocationId } from '../../../pages/NewScriptPage/ScriptForm/PrescriberSlice'
import { useOrganizationLocations } from '../hooks/useOrganizationLocations'
import { SelectLocationModal } from './SelectLocationModal'
import { JoinLocationModal } from './JoinLocationModal'

export const InitLocationModal = () => {
  const [view, setView] = useState<'select' | 'join'>('select')

  const dispatch = useAppDispatch()
  const prescriber = useAppSelector((s) => s.prescriber.prescriber)
  const authentication = useAppSelector((s) => s.authentication)
  const workLocationId = useAppSelector((s) => s.prescriber.workLocationId)

  const isLoggedIn = Boolean(authentication?.userId)
  const skipQueries = !isLoggedIn || Boolean(workLocationId)

  const { joinedLocations, availableLocations, isLoading } = useOrganizationLocations(skipQueries)

  const prescriberName = useMemo(() => {
    if (!prescriber) return ''
    return `${prescriber.givenNames ?? ''} ${prescriber.familyName ?? ''}`.trim()
  }, [prescriber])

  const handleSelectLocation = useCallback(
    (selectedLocationId: string) => {
      dispatch(setWorkLocationId(selectedLocationId))
    },
    [dispatch]
  )

  if (!isLoggedIn || workLocationId || isLoading) return null

  return (
    <>
      {view === 'select' && (
        <SelectLocationModal
          isOpen={true}
          locations={joinedLocations}
          prescriberName={prescriberName}
          title={prescriber?.title ?? ''}
          prescriberNumber={prescriber?.prescriberNumber ?? ''}
          onSelect={handleSelectLocation}
          onJoinNew={() => setView('join')}
          canJoinNewLocation={availableLocations.length > 0}
        />
      )}
      {view === 'join' && (
        <JoinLocationModal
          isOpen={true}
          onClose={() => setView('select')}
          availableLocations={availableLocations}
          hideCloseButton={true}
          onBack={() => setView('select')}
        />
      )}
    </>
  )
}
